import type React from 'react';

import formatInTimeZone from 'date-fns-tz/formatInTimeZone';
import ru from 'date-fns/locale/ru';
import parseISO from 'date-fns/parseISO';

import { useAvailablePeriod } from '@src/entities/available-periods';

type Props = {
	id: number;
};

export const AvailablePeriodDate: React.FC<Props> = ({ id }) => {
	const { availablePeriod } = useAvailablePeriod(id);

	return (
		<>
			{availablePeriod &&
				formatInTimeZone(parseISO(availablePeriod.start_time), 'Europe/Moscow', 'dd MMMM yyyy', {
					locale: ru,
				})}
		</>
	);
};
